import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

// Exporte l'identifiant tel quel, absence comprise : `main.tsx` refuse de
// démarrer sans lui. Un identifiant vide ne bloque pas MSAL, qui part quand
// même en OAuth et laisse `msal.interaction.status` coincé dans le
// localStorage — toute connexion ultérieure échoue alors en
// `interaction_in_progress`, même une fois `.env.local` en place.
export const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["https://graph.microsoft.com/.default"],
};

export const msalInstance = new PublicClientApplication(msalConfig);
